import { getAuthToken } from './session';

function trimSlashes(value, mode) {
  const str = String(value || '');
  if (mode === 'leading') return str.replace(/^\/+/, '');
  if (mode === 'trailing') return str.replace(/\/+$/, '');
  return str.replace(/^\/+|\/+$/g, '');
}

export function getApiV1BaseUrl() {
  const baseUrl = trimSlashes(process.env.REACT_APP_API_URL, 'trailing');
  const apiUri = trimSlashes(process.env.REACT_APP_API_URI, 'both');
  if (!apiUri) return baseUrl;
  if (!baseUrl) return `/${apiUri}`;
  return `${baseUrl}/${apiUri}`;
}

export function appendAccessToken(rawUrl) {
  const url = String(rawUrl || '');
  if (!url) return url;
  if (/^(blob:|data:)/i.test(url)) return url;

  const token = getAuthToken();
  if (!token) return url;
  if (/([?&])access_token=/.test(url)) return url;

  const separator = url.includes('?') ? '&' : '?';
  return `${url}${separator}access_token=${encodeURIComponent(token)}`;
}

export function buildProtectedImageUrl(
  imageId,
  thumbnail = false,
  cacheBuster
) {
  if (!imageId) return '';
  const base = getApiV1BaseUrl();
  let imagePath = `${base}/image?imageId=${encodeURIComponent(
    imageId
  )}&thumbnail=${thumbnail ? 'true' : 'false'}`;
  if (cacheBuster !== undefined && cacheBuster !== null && cacheBuster !== '') {
    imagePath += `&_t=${encodeURIComponent(String(cacheBuster))}`;
  }
  return appendAccessToken(imagePath);
}

export function fetchWithAuth(url, options = {}) {
  const token = getAuthToken();
  const headers = {
    ...(options.headers || {})
  };

  if (token && !headers.Authorization) {
    headers.Authorization = `Bearer ${token}`;
  }

  return fetch(appendAccessToken(url), {
    ...options,
    headers
  });
}
